// extracted by mini-css-extract-plugin
var _1 = "Files-modulefile__EgnWy";
var _2 = "Files-moduleuploadPlaceholder__bsWpy FileUploadPlaceholder-moduleFileUploadPlaceholder__LRagJ Files-modulefile__EgnWy";
export { _1 as "file", _2 as "uploadPlaceholder" }
